import React from 'react';
import ProductViewTemplate from '@/components/partials/ProductView/ProductViewTemplate';
import { ProductViewModes } from '@/utils/productStateUtils';
import { useProductEdit } from '@/components/partials/ProductView/ProductEdit/useProductEdit';

const ProductEdit = () => {
  const viewHook = useProductEdit();

  return (
    <ProductViewTemplate
      productViewMode={ProductViewModes.Edit}
      viewHook={viewHook}
    />
  );
};

export default ProductEdit;
